export const IndeCX = {
  key: "5f08a17de1db8a43195b1396",
  action: "6463c910e71a35001a842045",
  indicators: { test: "test" }
}
